<div class="bdo-container--single re-mb-45 md:re-mb-90">

  <div class="re-mb-45 md:re-mb-30 re-bg-white re-p-30 re-relative">

    @if (isLoading) {
      <bdo-loading></bdo-loading>
    }

    @if (isSuccess) {
      <h4 class="bdo-space--top bdo-space--bottom re-flex re-justify-center re-align-items-center">
        <img src="assets/icons/bdo/icon-check-big.svg" class="re-h-30 re-mr-5" [attr.alt]="'optout.success.altSuccess' | translate">
        <div> {{ 'optout.success.title' | translate }} </div>
      </h4>

      <p class="bdo-space--top re-text-center">
        {{ 'optout.success.message' | translate }}
      </p>

      <p class="bdo-space--top re-text-center">
        {{ 'optout.success.resubscribeHint' | translate }}
      </p>

      <div class="bdo-space--top re-flex re-justify-center re-align-items-center">
        <a [href]="reBaseData.hrefHomepage" class="bdo-button-primary">
          {{ 'optout.success.toHomepage' | translate }}
        </a>
      </div>
    }

    @if (isError) {
      <h4 class="bdo-space--top bdo-space--bottom re-flex re-justify-center re-align-items-center">
        <img src="assets/icons/system_icons/error_30x30.svg" class="re-h-40 re-mr-5" [attr.alt]="'optout.warning' | translate">
        <div class="re-pt-3">{{ 'optout.errorTitle' | translate }}</div>
      </h4>

      <p class="bdo-space--top re-text-center">{{ errorMessage }}</p>

      <div class="bdo-space--top re-flex re-justify-center re-align-items-center">
        <a [href]="reBaseData.hrefContact" class="bdo-button-primary">
          {{ 'optout.contactService' | translate }}
        </a>
      </div>
    }

  </div>
</div>
